import Num from '@flipster/utils/num';

import type { InlineBasisMode } from '../../calculator/tpsl-basis';

/**
 * Modal secondary HTML placeholder when value is empty.
 * Sign is applied on focus, not via placeholder. Must not be used as a stored value — empty value is `''`.
 */
export const modalSecondaryPlaceholder = '0.00';

/** i18n keys for inline (Variant A) placeholders by mode. */
export const inlinePlaceholderKeyByMode = {
  price: 'Autogen_common.r251126.s_Enter_price',
  pnl: 'Trade.r260723.Enter_pnl',
  roi: 'Trade.r260723.Enter_roi',
} as const satisfies Record<InlineBasisMode, string>;

export type InlinePlaceholderMessageKey = (typeof inlinePlaceholderKeyByMode)[InlineBasisMode];

export function getInlinePlaceholderKey(mode: InlineBasisMode): InlinePlaceholderMessageKey {
  return inlinePlaceholderKeyByMode[mode];
}

/**
 * Modal secondary display value from calc/forward.
 * Zero must stay empty (not `'0.00'` as a prefilled value) so placeholder can show.
 */
export function formatModalSecondaryDisplay(value: string | null | undefined): string {
  if (value == null || value === '') return '';
  const n = Num(value);
  if (!n.isFinite() || n.isZero()) return '';
  return n.toFixed(2);
}
